import * as d3Shape from 'd3-shape';
import React from 'react';

import colorScales, { greyColorScale } from '../../../utils/colorScales';
import { Cone } from '../types';

interface ConeProps extends Omit<Cone, 'id'> {
    innerEdge: number;
    outerEdge: number;
    colorScaleLabel: string;
    multiplicationRatio: number;
}

const Cone = ({ angleRange, segments, innerEdge, outerEdge, colorScaleLabel, multiplicationRatio }: ConeProps) => {
    const colorScale = (colorScales.find(({ label }) => label === colorScaleLabel) || greyColorScale)?.scale;
    let startForSegment = innerEdge;

    return (
        <g>
            {segments.map((segment) => {
                const colour = colorScale((segment.bin + 1) / segments.length);
                const lengthOfSegment = (outerEdge - innerEdge) * segment.length * multiplicationRatio;
                const d = d3Shape.arc<Omit<d3Shape.DefaultArcObject, 'padAngle'>>()({
                    innerRadius: startForSegment,
                    outerRadius: startForSegment + lengthOfSegment,
                    startAngle: (angleRange.min * Math.PI) / 180,
                    endAngle: (angleRange.max * Math.PI) / 180,
                }) as string;

                startForSegment += lengthOfSegment;

                return <path key={segment.bin} fill={colour} d={d} />;
            })}
        </g>
    );
};

export default Cone;
